import { render, staticRenderFns } from "./UserWithoutFunctionality.vue?vue&type=template&id=7d7477b6"
import script from "./UserWithoutFunctionality.vue?vue&type=script&lang=js"
export * from "./UserWithoutFunctionality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports